// extracted by mini-css-extract-plugin
module.exports = {"printButton":"ViewApplicationForm_printButton__2QJ4Q"};